import { createRecipe } from './runtime.mjs';

const tagConfig = {"name":"tag","className":"ds-tag","defaultVariants":{"variant":"default"},"variantMap":{"variant":["default","inverse","glass","brand","pro","beta","success","warning","error","info","outline"]}}

export const tag = /* @__PURE__ */ createRecipe(tagConfig)